const NS = 'WoolLabOnboardingBlock';
const CLS = 'woolLabOnboardingBlock';

import Handlebars from 'handlebars';
import slick from 'slick-carousel';

export class WoolLabOnboardingBlock {

	constructor(el) {
		this.$el = $(el);

		this.$questionsCarousel = this.$el.find(`.${CLS}-questionsCarousel`);
		this.$questionContainer = this.$el.find(`.${CLS}-questionContainer`);
		this.$nextBtn = this.$el.find(`.${CLS}-nextBtn`);
		this.$prevBtn = this.$el.find(`.${CLS}-prevBtn`);

		this.$progressBarInner = this.$el.find(`.${CLS}-progressBar-inner`);

		this.$sliderPrevBtn = this.$el.find(`.${CLS}-slider-nextBtn`);
		this.$sliderNextBtn = this.$el.find(`.${CLS}-slider-nextBtn`);
		this.$questionCount = this.$el.find(`.${CLS}-questionCount`);

		this.$startScreen = this.$el.find(`.${CLS}-startScreen`);
		this.$startBtn = this.$el.find(`.${CLS}-startScreen-startBtn`);
		this.$endScreen = this.$el.find(`.${CLS}-endScreen`);

		this.$loadingScreen = this.$el.find(`.${CLS}-loadingScreen`);

		this.onLastSlide = false;
		this.currentSlide = 1;

		this.$form = this.$el.find(`.${CLS}-form`);
		this.$formAction = this.$form.attr('action');

		this.$questionsCarousel.on('init reInit afterChange', (event, slick, currentSlide, nextSlide) => {
			let i = (currentSlide ? currentSlide : 0) + 1;

			this.currentSlide = i;

			if (i / slick.slideCount >= 1) {
				this.onLastSlide = true;
			} else {
				this.onLastSlide = false;
			}

			this.$questionCount.html('question ' + i + '/' + slick.slideCount);
			let percentage = i/slick.slideCount;
			this.$progressBarInner.css('transform', `scaleX(${percentage})`);
		});

		const options = {
			infinite: false,
			draggable: false,
			dots: true,
			arrows: false,
		};

		this.$questionsCarousel.slick(options);

		// Init
		$.each(this.$questionContainer, function() {
			const checkboxes = $(this).find(`input[type="checkbox"]`);
			const radios = $(this).find(`input[type="radio"]`);
			const nextBtn = $(this).find('[data-next-btn]');

			// Field validation - radio
			radios.on('change', (event) => {
				nextBtn.removeClass('disabled');
			});
			
			// Field validation - checkboxes
			checkboxes.on('change', (event) => {
				if($(checkboxes).is(':checked') ) {
					nextBtn.removeClass('disabled');
				} else {
					nextBtn.addClass('disabled');
				}
			});

			// check if already ticked
			if ($(radios).is(':checked') ) {
				nextBtn.removeClass('disabled');
			}
			if ($(checkboxes).is(':checked') ) {
				nextBtn.removeClass('disabled');
			}
		});

		this.handleButtons();
	}

	hideScreen(elem) {
		elem.css('opacity', '0');
		elem.css('pointer-events', 'none');
	}

	showScreen(elem) {
		elem.css('opacity', '1');
		elem.css('pointer-events', 'auto');
	}

	handleButtons() {
		this.$startBtn.on('click', (event) => {
			this.hideScreen(this.$startScreen);
		});

		this.$prevBtn.on('click', (event) => {
			event.preventDefault();
			this.$questionsCarousel.slick('slickPrev');
			if (this.currentSlide === 1) {
				this.showScreen(this.$startScreen);
			} else {
				this.$questionsCarousel.slick('slickPrev');
			}
		});

		this.$nextBtn.on('click', (event) => {
			event.preventDefault();
			if (this.onLastSlide) {
				this.handleFormSubmission();
			} else {
				this.$questionsCarousel.slick('slickNext');
			}
		});

		this.$sliderNextBtn.on('click', (event) => {
			event.preventDefault();

			if (!$(event.target).hasClass('disabled')) {
				if (this.onLastSlide) {
					this.handleFormSubmission();
				} else {
					this.$questionsCarousel.slick('slickNext');
				}
			}
		});
	}

	handleFormSubmission() {
		this.$loadingScreen.addClass('active');

		$.ajax({
			type: 'POST',
			url: this.$formAction,
			data: this.$form.serialize(),
			success: (data) => {
				this.$loadingScreen.removeClass('active');
				this.showScreen(this.$endScreen);
			},
		});
	}
}
